export const CONTRACTS_FETCH = 'CONTRACTS_FETCH';
export const CONTRACTS_DOWNLOAD = 'CONTRACTS_DOWNLOAD';
export const INITIATE_CONTRACTS_FETCH = 'INITIATE_CONTRACTS_FETCH';
export const ORDER_OPTIONS_FETCH = 'ORDER_OPTIONS_FETCH';
export const SEND_CO_BUYER_EMAIL = 'SEND_CO_BUYER_EMAIL';
export const SET_CONTRACTS_TOAST = 'SET_CONTRACTS_TOAST';
export const RESET_CONTRACTS_TOAST = 'RESET_CONTRACTS_TOAST';
